<template>
    <div class="m-2">
        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Активен</span>
            <span class="w-2/3">
                <CBadge :color="entity.enabled ? 'success' : 'secondary'">
                    {{ entity.enabled ? "Да" : "Нет" }}
                </CBadge>
            </span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Название</span>
            <span class="w-2/3">{{ entity.name }}</span>
        </div>

        <div class="flex items-center mt-4">
            <span class="w-1/3 font-bold">Ссылка на страницу</span>
            <span class="w-2/3 font-bold" style="font-size: 20px;">
                {{ 'https://mircity24.ru/#!/promo/' + entity.url }}
            </span>
        </div>

        <CCard class="mt-4">
            <CCardBody>
                <div class="flex items-center">
                    <span class="w-1/3 font-bold">Картинка основная</span>
                    <span class="w-2/3">
                        <CImg :src="pictureUrl(entity.picture)" class="m2" width="200" />
                    </span>
                </div>

                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Заголовок</span>
                    <span class="w-2/3">{{ entity.title }}</span>
                </div>

                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Описание</span>
                    <span class="w-2/3" v-html="entity.description"></span>
                </div>
                
                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">События</span>
                    <span class="w-2/3">
                        <div v-for="(event) in entity.events" :key="event.id" class="mb-2">
                            <strong>{{ event.current_date_title }}</strong>
                            <ul>
                                <li v-for="(item, idx) in event.current_date_times" :key="idx">
                                    {{ item.time }} - {{ item.text }}
                                </li>
                            </ul>
                        </div>
                    </span>
                </div>

                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Описание под событиями</span>
                    <span class="w-2/3" v-html="entity.footer_description"></span>
                </div>
            </CCardBody>
        </CCard>

        <CCard v-if="entity.button_name">
            <CCardBody>
                <div class="flex items-center">
                    <span class="w-1/3 font-bold">Текст на кнопке</span>
                    <span class="w-2/3">{{ entity.button_name }} </span>
                </div>

                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Цвет кнопки</span>
                    <span class="w-2/3">{{ entity.button_color }} </span>
                </div>

                <div class="flex items-center mt-4">
                    <span class="w-1/3 font-bold">Ссылка</span>
                    <span class="w-2/3">{{ entity.button_url }} </span>
                </div>
            </CCardBody>
        </CCard>
    </div>
</template>

<script>
import { CCard } from '@coreui/vue';

export default {
    name: 'AdsCampaignCard',
    props: {
        entity: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        pictureUrl(picture) {
            return picture ? process.env.VUE_APP_STATIC_BASE_URL + '/' + picture : '';
        },
    },
};
</script>
